/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// ------------------------------------------------------
import Dir from "Components/Dir";
import FileViewer from "Components/FileViewer";
// ------------------------------------------------------
import { partitionFiles, eraseCollection } from "Redux/collections/actions";
// ------------------------------------------------------

// ------------------------------------------------------
// ------------------------------------------------------
const Files = () => {
  const dispatch = useDispatch();
  const { collections, repository, dirs } = useSelector(
    (state) => state.project
  );

  const partition = () => {
    if (repository) {
      const flatFiles = Object.keys(repository).map(
        (fileId) => repository[fileId]
      );
      dispatch(partitionFiles(flatFiles));
    }
  };

  if (!dirs) return <div></div>;

  const allFileIds = Object.keys(repository);
  const assignedIds = [],
    unassignedIds = [];
  for (const collection of collections) {
    assignedIds.push(...collection.fileids);
  }
  for (const fileId of allFileIds) {
    if (!assignedIds.includes(fileId)) {
      unassignedIds.push(fileId);
    }
  }

  return (
    <div>
      <FileViewer />
      <div className="columns">
        <div className="column is-half">
          <div className="box">
            <div className="title is-6">Uploaded Files</div>
            {dirs.map((dir) => (
              <Dir key={dir.id} dir={dir} />
            ))}
          </div>
        </div>
        <div className="column is-half">
          <div className="box">
            <div className="title is-6">
              Data Files Grouped By Column Headers
            </div>
            <button
              style={{ display: "none" }}
              className="button is-small"
              onClick={partition}
            >
              <span className="icon is-small">
                <i className="fa-duotone fa-grid-dividers" />
              </span>
              <span>Partition</span>
            </button>

            <aside className="menu">
              <p className="menu-label">Data Groups</p>
              <ul className="menu-list">
                {collections.map((collection) => (
                  <Collection key={collection.id} collection={collection} />
                ))}
                {unassignedIds.length > 0 ? (
                  <p className="menu-label">Unassigned</p>
                ) : null}
                <ul className="tiny">
                  {unassignedIds.map((fileId) => {
                    const file = repository[fileId];
                    return (
                      <li key={fileId}>
                        <a role="button" tabIndex={0}>{file.name}</a>
                      </li>
                    );
                  })}
                </ul>
              </ul>
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Files;

// ------------------------------------------------------
// ------------------------------------------------------
const Collection = ({ collection }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { repository } = useSelector((state) => state.project);
  return (
    <li>
      <a
        role="button"
        tabIndex={0}
        className="collection-row"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
        onClick={() => setOpen(!open)}
      >
        <div className="collection-head">
          <span className="icon is-small">
            <i
              className={
                open ? "fa-duotone fa-angle-down" : "fa-duotone fa-angle-right"
              }
            />
          </span>
          <div>{collection.title}</div>
        </div>
        <div className="collection-buttons">
          <div className="buttons has-addons">
            <div
              className="button is-small"
              onClick={(evt) => {
                evt.stopPropagation();
                dispatch(eraseCollection(collection.id));
              }}
            >
              <span className="icon is-small">
                <i className="fa-duotone fa-trash" />
              </span>
            </div>
          </div>
        </div>
      </a>
      {open ? (
        <ul className="tiny">
          {collection.fileids.map((fileId) => {
            const file = repository[fileId];
            return (
              <li key={fileId}>
                <a role="button" tabIndex={0}>{file.name}</a>
              </li>
            );
          })}
        </ul>
      ) : null}
    </li>
  );
};
